import React, { type ReactElement } from 'react';

import ProFocusOption from './ProFocusOption';
import { ProFocusOnAIArticles } from './constants';
import { ProSubscriberNotBotProps } from './interfaces';

const ProFocusOnAI = ({ isProSubscriberNotBot }: ProSubscriberNotBotProps): ReactElement => {
  return (
    <article className="mt-48 w-full lg:px-40">
      <h3 className="m-0 text-center font-suisse-works text-headline-xxs text-black sm:text-headline-xs">
        Focus on AI
      </h3>
      <div className="flex flex-col sm:mt-24 sm:flex-row sm:justify-between">
        {ProFocusOnAIArticles.map((props, index) => (
          <ProFocusOption
            key={`profocusoption-${index}`}
            index={index}
            isProSubscriberNotBot={isProSubscriberNotBot}
            {...props}
          />
        ))}
      </div>
    </article>
  );
};

export default ProFocusOnAI;
